"use strict";

import Player from "@vimeo/player";

const playButton = document.querySelector(".video-play-button");
const iframe = document.querySelector("iframe");
const player = new Player(iframe);

playButton.addEventListener("click", () => {
  player.play();
  iframe.classList.add("visible");
});

